"use client";

import { useEffect, useState } from "react";

interface ServiceWorkerState {
  isSupported: boolean;
  isRegistered: boolean;
  isUpdating: boolean;
  registration: ServiceWorkerRegistration | null;
}

export function useServiceWorker(): ServiceWorkerState {
  const [state, setState] = useState<ServiceWorkerState>({
    isSupported: false,
    isRegistered: false,
    isUpdating: false,
    registration: null,
  });

  useEffect(() => {
    if (!("serviceWorker" in navigator)) {
      setState((prev) => ({ ...prev, isSupported: false }));
      return;
    }

    setState((prev) => ({ ...prev, isSupported: true }));

    window.addEventListener("load", async () => {
      try {
        const registration = await navigator.serviceWorker.register("/sw.js", {
          scope: "/",
        });

        setState((prev) => ({
          ...prev,
          isRegistered: true,
          registration,
        }));

        registration.addEventListener("updatefound", () => {
          setState((prev) => ({ ...prev, isUpdating: true }));
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener("statechange", () => {
              if (newWorker.state === "activated") {
                setState((prev) => ({ ...prev, isUpdating: false }));
                window.location.reload();
              }
            });
          }
        });
      } catch {
        // silently handle service worker registration errors
      }
    });
  }, []);

  return state;
}

export function ServiceWorkerRegistration() {
  useServiceWorker();
  return null;
}